module.exports = __webpack_public_path__ + "static/img/join_us_1.f140c3a1.png";